import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Sun = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M8.90385 5.25C8.90385 7.26796 7.26796 8.90385 5.25 8.90385M8.90385 5.25C8.90385 3.23204 7.26796 1.59615 5.25 1.59615M8.90385 5.25H10M5.25 8.90385C3.23204 8.90385 1.59615 7.26796 1.59615 5.25M5.25 8.90385V10M1.59615 5.25C1.59615 3.23204 3.23204 1.59615 5.25 1.59615M1.59615 5.25H0.5M5.25 1.59615V0.5M1.89124 1.89124L2.66634 2.66634M7.83365 7.83365L8.60875 8.60875M8.60876 1.89124L7.83366 2.66634M2.66635 7.83365L1.89125 8.60875" strokeLinecap="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline" viewBox="0 0 11 11" strokeWidth={1}>{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Sun };